import React from 'react'
import {injectIntl} from 'react-intl'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import IconsList from 'components/IconsList'
import {getIcons} from 'utils/utils'

class ModuleConfig extends React.PureComponent {
    constructor(props) {
        super(props)

        const icons = getIcons()

        this.state = {
            name: props.name,
            icon: props.icon ? props.icon : icons[0],
            default: props.default
        }

    }

    createModule = () => {
        this.props.createModule({name: this.state.name, icon: this.state.icon, isDefault: this.state.default})
        this.props.handleClose()
    }

    deleteModule = () => {
        this.props.deleteModule()
    }

    editModule = () => {
        this.props.editModule({name: this.state.name, icon: this.state.icon, isDefault: this.state.default})
        this.props.handleClose()
    }

    render() {
        const {intl} = this.props

        return (
            <React.Fragment>
                <DialogTitle>
                    {this.props.edit ?
                        intl.formatMessage({id: "main.module_edit_title"}, {name: this.props.name}) :
                        intl.formatMessage({id: "main.module_create_title"})
                    }
                </DialogTitle>
                <DialogContent>
                    <TextField variant="standard"
                        value={this.state.name}
                        onChange={(e) => this.setState({ name: e.target.value })}
                        label={intl.formatMessage({id: "main.module_name"})}
                        sx={{
							width: '100%',
							marginBottom: '20px',
						}}
                        InputLabelProps={{
                            shrink: true
                        }}
                        inputProps={{
                            maxLength: global.NAME_MAX_LENGTH
                        }}
                    />
                    <IconsList
                        onClick={(icon) => this.setState({ icon })}
                        icon={this.state.icon}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.state.default}
                                onChange={(e) => this.setState({ default: e.target.checked })}
                            />
                        }
                        label={intl.formatMessage({id: "main.module_default"})}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    {this.props.edit &&
                        <Button variant="contained"
                            disabled={this.props.count === 1}
                            onClick={this.deleteModule}
                            color="secondary"
                        >
                            {intl.formatMessage({id: "app.confirm_delete"})}
                        </Button>
                    }
                    {this.props.edit ?
                        <Button variant="contained"
                            disabled={!this.state.name || this.state.name.replace(/\s/g, '') === ''}
                            onClick={this.editModule}
                            color="primary"
                        >
                            {intl.formatMessage({id: "app.confirm_save"})}
                        </Button>
                        :
                        <Button variant="contained"
                            disabled={!this.state.name || this.state.name.replace(/\s/g, '') === ''}
                            onClick={this.createModule}
                            color="primary"
                        >
                            {intl.formatMessage({id: "app.confirm_create"})}
                        </Button>
                    }
                </DialogActions>
            </React.Fragment>
        )
    }
}

export default injectIntl(ModuleConfig)
